import axios from '@axios';
import qs from 'qs';
import _ from 'lodash';

export function getStops(query) {
    let queryString = qs.stringify(query);

    return axios.get('/mobility-stops?' + queryString);
}
